import { Field } from 'formik';
import { SttInput } from '@stt-componentes/core';
import { FUNCIONARIO_ENVIO } from '../fieldNames';

const ResponsavelEnvio = ({ strings }) => {
    return (
        <Field name={FUNCIONARIO_ENVIO}>
            {({
                field
            }) => (
                <SttInput
                    {...field}
                    label={strings.responsavelEnvio}
                />
            )}
        </Field>
    )
};

export default ResponsavelEnvio;